import React, { useEffect, useState } from "react";
import { useDataProvider } from "react-admin";
import { GetParam } from "utils/tools";
import { Grid, makeStyles, Typography } from "@material-ui/core";
import SanitizedGrid from "../../components/SanitizedGrid";
import StudentSubsidyHistoryTable from "./components/StudentSubsidyHistoryTable";
import HeaderContent from "../../components/layout/components/HeaderContent";

const useStyles = makeStyles({
  title: {
    marginTop: 10,
  },
});

const StudentSubsidyList = () => {
  const classes = useStyles();
  const param = GetParam();
  const provider = useDataProvider();

  const [selectedStudent, setSelectedStudent] = useState<IStudent>();

  const studentId = param.get("studentId");

  let breadcrumbValue = [{ link: "", title: "", params: "" }];

  if (param.get("parentId")) {
    breadcrumbValue = [
      {
        title: "Parents",
        link: `/parents/${param.get("parentId")}/show`,
        params: "",
      },
      {
        title: "Students",
        link: `/students/${param.get("studentId")}/show`,
        params: `?parentId=${param.get("parentId")}`,
      },
      {
        title: "Payment Setting",
        link: `/students/${param.get("studentId")}/show/6`,
        params: `?parentId=${param.get("parentId")}`,
      },
      {
        title: "Subsidy History",
        link: "",
        params: "",
      },
    ];
  } else {
    breadcrumbValue = [
      {
        title: "Students",
        link: `/students/${param.get("studentId")}/show`,
        params: "",
      },
      {
        title: "Payment Setting",
        link: `/students/${param.get("studentId")}/show/6`,
        params: "",
      },
      {
        title: "Subsidy History",
        link: "",
        params: "",
      },
    ];
  }

  const breadcrumb = breadcrumbValue;

  useEffect(() => {
    if (studentId) {
      provider.getOne("students", { id: studentId }).then(({ data }) => {
        setSelectedStudent(data as IStudent);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [studentId]);

  return (
    <>
      <HeaderContent
        breadcrumb={breadcrumb}
        headerTitle="Student Subsidies"
        isNotHaveSchoolFilter
      />

      <SanitizedGrid>
        <Grid item xs={12}>
          <Typography variant="h6" gutterBottom className={classes.title}>
            Subsidy History - {selectedStudent?.firstName}{" "}
            {selectedStudent?.lastName}
          </Typography>
        </Grid>

        <Grid item xs={12}>
          {selectedStudent && (
            <StudentSubsidyHistoryTable
              studentId={Number(studentId)}
              activeStudentSubsidyId={selectedStudent.activeStudentSubsidyId}
            />
          )}
        </Grid>
      </SanitizedGrid>
    </>
  );
};

export default StudentSubsidyList;
